import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = {};

const fetchOnce = (path) => (cache[path] ||= axios.get(`${API}${path}`).then((r) => r.data));

export function useProducts() {
  const [products, setProducts] = useState([]);
  useEffect(() => { fetchOnce("/products").then(setProducts).catch(() => {}); }, []);
  return products;
}

export function useCoaLibrary() {
  const [rows, setRows] = useState([]);
  useEffect(() => { fetchOnce("/coa-library").then(setRows).catch(() => {}); }, []);
  return rows;
}

export const hplcPath = (seedStr) => {
  let s = 0;
  for (const c of seedStr) s += c.charCodeAt(0);
  const rand = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
  const pts = [[0, 90]];
  for (let x = 10; x <= 290; x += 8) {
    const peak = Math.exp(-Math.pow(x - (140 + rand() * 30), 2) / 300) * 78;
    pts.push([x, 90 - peak - rand() * 5]);
  }
  pts.push([300, 90]);
  return pts.map((p, i) => `${i === 0 ? "M" : "L"}${p[0]},${p[1].toFixed(1)}`).join(" ");
};

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
